<template>
  <v-dialog persistent v-bind="[$attrs, $props]" width="800">
    <v-card class="white" rounded="lg">
      <v-row class="base-modal__divider ma-0 align-center">
        <v-col cols="10" class="pa-4 d-flex align-center">
          <p class="black--text subtitle-1 font-weight-bold mb-0">
            {{ $t("changeEvent.title") }}
          </p>
        </v-col>
        <v-col cols="2" class="pa-4 d-flex align-center justify-end">
          <BaseButton
            type-button="tertiary"
            svg-icon-name="remove"
            @click="closeModal"
          />
        </v-col>
      </v-row>
      <v-row class="ma-0 pa-6 gray15">
        <v-col cols="12">
          <p class="caption black--text mb-4 font-weight-medium">
            {{ $t("changeEvent.selectLabel") }}
          </p>
          <v-select
            v-model="selectedExternalId"
            :items="events"
            item-text="name"
            item-value="externalId"
            :label="$t('changeEvent.eventName')"
            outlined
            dense
            hide-details
            class="modal-change-corporate-event__select"
          />
        </v-col>
      </v-row>
      <v-row class="ma-0 pa-6 justify-center">
        <v-col cols="auto">
          <BaseButton
            type-button="primary"
            :loading="loading"
            :disabled="loading || !selectedExternalId"
            @click="submit"
          >
            {{ $t("changeEvent.confirm") }}
          </BaseButton>
        </v-col>
      </v-row>
    </v-card>
  </v-dialog>
</template>
<script lang="ts">
import Component, { mixins } from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { State } from "vuex-class";
import { ActionMixin } from "@/mixins/ActionMixin";
import { encodeId } from "@/utils/hashids";
import {
  TenantSummaryV2Response,
  UserAuthSystemResponse,
} from "@/modules/onboarding/types";

@Component
export default class ModalChangeCorporateEvent extends mixins(ActionMixin) {
  @Prop({ default: "" }) corporateUrl: string;

  selectedExternalId = "";
  loading = false;

  @State((state) => state.onboarding.userAuthSystem)
  userAuthSystem: UserAuthSystemResponse | null;

  get events(): TenantSummaryV2Response[] {
    return this.userAuthSystem?.externalEvents || [];
  }

  closeModal(): void {
    this.$emit("close");
  }

  submit(): void {
    if (!this.selectedExternalId || !this.userAuthSystem) return;
    this.loading = true;
    try {
      const userId = encodeId(this.userAuthSystem.corporationExternalId);
      const eventId = encodeId(this.selectedExternalId);
      const language = this.$root.$i18n.locale || "pt";
      window.location.href = `${this.corporateUrl}/onboarding/${userId}/${eventId}/${language}`;
    } catch (error: any) {
      const messageDefaultTitle = this.$t("toast.error");
      const title = error.response?.data?.title || messageDefaultTitle;
      this.showAlertNotification({
        message: error?.response?.data?.message || this.$t("misc.error"),
        color: "redAlert",
        icon: "cancel",
        title: title,
      });
      this.loading = false;
    }
  }
}
</script>
<style lang="sass">
.modal-change-corporate-event__
  &select
    .v-input__control > .v-input__slot
      background: white !important
</style>
